const state = {
    newTabName: '',
    tabNameChangeNum: -1,
    tabContentChange: null,
    tabContentChangeNum: -1,
    currentTab: null,
    currentTabChange: -1,
}

const getters = {
    getTabNameChange: state => state.tabNameChangeNum,
    getTabContentChange: state => state.tabContentChangeNum,
    getCurrentTabChange: state => state.currentTabChange
}

const actions = {
}

const mutations = {
    setTabName(state, newName){
        state.newTabName = newName;
        state.tabNameChangeNum++;
    },
    setTabContentChagne(state, changeObj){
        state.tabContentChange = changeObj;
        state.tabContentChangeNum++;
    },
    setCurrentTab(state, cTab){
        state.currentTab = cTab;
        state.currentTabChange++;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}